// СИНХРОННЫЙ доступ к localStorage без исключений.
//
// Отдельный файл, а не переиспользование `stores/_storage.ts`: тот адаптер
// типизирован как `StateStorage` из Zustand, где `getItem` может вернуть
// промис. Для снапшота доступности это неприемлемо — он читается на пути
// первого рендера, и «может быть промис» здесь не тип, а сломанный контракт.
// Плюс граница слоёв: `stores/` не импортируется из `lib/` и наоборот.
//
// Молчаливое проглатывание ошибок — намеренное: приватный режим Safari,
// переполненная квота и WebView с выключенным storage не должны ронять
// приложение. Худшее последствие — снапшота нет, и клиент уходит в режим
// «неизвестно» (читать можно, генерировать нельзя).

export function readLocalItem(key: string): string | null {
	try {
		if (typeof window === "undefined") return null;
		return window.localStorage.getItem(key);
	} catch {
		return null;
	}
}

export function writeLocalItem(key: string, value: string): void {
	try {
		if (typeof window === "undefined") return;
		window.localStorage.setItem(key, value);
	} catch {
		/* приватный режим / переполненная квота — снапшот необязателен */
	}
}

export function removeLocalItem(key: string): void {
	try {
		if (typeof window === "undefined") return;
		window.localStorage.removeItem(key);
	} catch {
		/* см. выше */
	}
}
